import InfiniteDataList from './infinite-data-list.jsx';
import './infinite-data-list.scss';

export default InfiniteDataList;
